import React from "react";

interface DownloadProps {
  color?: string;
}

const Download: React.FC<DownloadProps> = ({ color = "#fff" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1641 1.81407e-08C9.56606 1.81407e-08 9.08073 0.485008 9.08073 1.08333V12.5255L5.83073 9.31017L4.30756 10.8333L9.38515 15.9456C9.80874 16.3681 10.5194 16.3681 10.943 15.9456L16.0206 10.8333L14.4974 9.31017L11.2474 12.5255V1.08333C11.2474 0.485008 10.7621 -0.000108315 10.1641 1.81407e-08ZM1.4974 13C0.899396 13 0.414062 13.4853 0.414062 14.0833V16.25C0.414062 18.6431 2.35431 20.5833 4.7474 20.5833H15.5807C17.9738 20.5833 19.9141 18.6431 19.9141 16.25V14.0833C19.9141 13.4853 19.4287 13 18.8307 13C18.2327 13 17.7474 13.4853 17.7474 14.0833V16.25C17.7474 17.4471 16.7778 18.4167 15.5807 18.4167H4.7474C3.55031 18.4167 2.58073 17.4471 2.58073 16.25V14.0833C2.58073 13.4853 2.0954 13 1.4974 13Z"
        fill={color}
      />
    </svg>
  );
};

export default Download;
